import { Download, History } from "lucide-react";
import { fmtDate } from "../proposal/format";

// Superseded, fully executed versions the client can still download.
export function VersionHistory({ versions, versionUrl }) {
  const items = (versions || []).filter((v) => v.downloadable);
  if (!items.length) return null;
  return (
    <div className="rounded-lg border border-stone-200 bg-white p-4 sm:p-5 flex flex-col gap-3" data-testid="commission-version-history">
      <p className="flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] uppercase text-stone-500"><History className="w-3.5 h-3.5" /> Previous versions</p>
      <ul className="flex flex-col divide-y divide-stone-100">
        {items.map((v) => (
          <li key={v.index} className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 py-2.5 text-sm text-stone-700" data-testid={`commission-version-${v.version}`}>
            <span>
              <span className="font-semibold">Version {v.version}</span>
              {v.signed_at ? <> · signed by {v.signed_by} on {fmtDate(v.signed_at)}</> : null}
              {v.superseded_at ? <span className="text-stone-500"> · superseded {fmtDate(v.superseded_at)}</span> : null}
            </span>
            <a href={versionUrl(v.index)} className="inline-flex items-center gap-1.5 text-[#1B4F8A] font-medium underline underline-offset-2 hover:text-[#143E72]" data-testid={`commission-version-${v.version}-download`}>
              <Download className="w-3.5 h-3.5" /> Download
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
